<template>
    <i class="i-like"
       :class="{'i-liked': isLiked}"
       @click="isLiked = !isLiked"></i>
</template>

<script>
export default {
    name: "",
    data () {
        return {
            isLiked: this.name ? !!localStorage.getItem(this.name) : false
        }
    },
    props: {
        name: String
    },
    watch: {
        isLiked (val) {
            localStorage.setItem(this.name, val);
        }
    }
}
</script>

<style scoped>
</style>
